module.exports = __webpack_public_path__ + "img/efficacy-table.f61e12d7.svg";